import {Injectable, Renderer2, RendererFactory2} from '@angular/core';
import {Router} from '@angular/router';
import {Subject} from 'rxjs';
import {SpinnerService} from 'src/app/api/module/erp/shared/services/spinner-service.service';

@Injectable({
  providedIn: 'root',
})
export class ScrollService {
  private renderer: Renderer2;

  constructor(
    rendererFactory: RendererFactory2,
    private router: Router,
    private _spinnerService: SpinnerService,
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  private sectionIdSubject = new Subject<string>();
  sectionId$ = this.sectionIdSubject.asObservable();

  scrollToElement(selector: string, offset: number = 0): void {
    this.iniciarSpinner();
    // const element = document.querySelector(selector);
    // if (element) {
    //   window.scrollTo({
    //     top: element.getBoundingClientRect().top + window.scrollY - offset,
    //     behavior: 'smooth',
    //   });
    // }

    setTimeout(() => {
      const scrollTarget = document.getElementById(selector);
      if (scrollTarget) {
        // Remove qualquer estilo antigo
        scrollTarget.style.marginTop = '';
        // Scroll suave até o elemento
        scrollTarget.scrollIntoView({behavior: 'smooth', block: 'start'});
      }
      // Espera a animação do colapso (~300ms do Bootstrap)
    }, 350);

    this.pararSpinner(1000);
  }

  setStyle(selector: string, styles: {[key: string]: string}): void {
    const element = document.querySelector(selector);
    if (element) {
      Object.keys(styles).forEach(style => {
        element.scrollIntoView();
        this.renderer.setStyle(element, style, styles[style]);
      });
    }
  }

  navigateToSection(sectionId: string, urlCaminho?: any, isMobile?: string, marginTop?: any): void {
    this.router.navigateByUrl('/' + urlCaminho + '/' + sectionId).then(() => {
      setTimeout(() => {
        let selector = document.querySelector('#' + sectionId);
        if (selector !== null) {
          this.goSection(selector, marginTop);
          this.sectionIdSubject.next(sectionId); // Emitir o ID da seção navegada
        }

        // Dispara um evento customizado para o header reinicializar o menu
        window.dispatchEvent(new CustomEvent('menuPrecisaReiniciar'));
      }, 100);
    });
  }
  resetUrlToDefault(): void {
    const defaultSection = 'saude';
    this.router.navigate(['/portal', defaultSection]);
  }

  goSection(selector: any, marginTop: number) {
    selector.style.scrollMarginTop = `${marginTop}px`;
    selector.scrollIntoView({behavior: 'smooth', block: 'start'});
  }

  updateCurrentSectionFromUrl(): void {
    const url = window.location.href;
    const sectionId = url.split('#/')[1];
    if (sectionId) {
      this.sectionIdSubject.next(sectionId);
    } else {
      this.sectionIdSubject.next('saude'); // default section
    }
  }
  iniciarSpinner() {
    this._spinnerService.show();
  }

  pararSpinner(ms?: number) {
    return new Promise(resolve => {
      setTimeout(() => {
        this._spinnerService.hide();
        resolve(true);
      }, ms);
    });
  }
}
